<template>
  <div
    class="rounded-5 border-2 border-dashed p-3"
    :class="
      disabled
        ? 'border-red-300 bg-red-50 text-red-500'
        : 'border-gray-300 bg-blue-50 text-gray-500'
    "
  >
    {{
      disabled
        ? $t("OFFER_CUSTOMISATION.MAX_NUMBER_OF_PRIMARY_FIELDS")
        : $t("OFFER_CUSTOMISATION.DRAG_AND_DROP_PLACEHOLDER")
    }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  disabled?: boolean;
}>();
</script>
